import React from 'react'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
// import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

export const therapies = [
  {
    nr: 1,
    category: 'Diagnosen',
    title: 'Kopfschmerzen',
    subtitle: 'Hirnaktivität messen bringt nichts',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-kopfschmerzen.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Gezielte Fragen und eine medizinische
              Untersuchung reichen, um festzustellen, ob Kopfschmerzen einen
              gefährlichen Ursprung haben.
            </p>
            <p>
              <b>Nutzen:</b> Keine Untersuchung ohne Nutzen, weniger Kosten.
            </p>
            <p>
              <b>Hintergrund:</b> In gewissen Fällen können bei Kopfschmerzen
              weiterführende Untersuchungen gemacht werden, um eine gefährliche
              Ursache auszuschliessen. Die Elektroenzephalografie (EEG)
              ermöglicht die Messung der elektrischen Hirnaktivität, denn diese
              verändert sich bei gewissen Krankheiten wie beispielsweise bei der
              Epilepsie. Bei der Abklärung von Kopfschmerzen ist ein EEG jedoch
              nutzlos. Diese Methode generiert zusätzliche Kosten und bringt
              weder einen Vorteil im Vergleich mit anderen Untersuchungen, noch
              beeinflusst sie die Entscheidung über den Kostenträger.
            </p>
            <p>
              <b>Fachgesellschaft:</b> Neurologie
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 2,
    category: 'Diagnosen',
    title: 'Borreliose',
    subtitle: 'Keine Tests bei unklaren Symptomen',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-borreliose.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Bei unklaren Beschwerden des Bewegungsapparates
              sollten keine Borrelien-Tests durchgeführt werden.
            </p>
            <p>
              <b>Nutzen:</b> Weniger unnötige Kosten, weniger falsch positive
              Ergebnisse, weniger unnötige Behandlungen.
            </p>
            <p>
              <b>Hintergrund:</b> Ein positives Resultat bei einem
              Borrelien-Bluttest bedeutet nicht unbedingt, dass aktuelle
              Beschwerden durch eine Infektion mit den zeckenübertragenen
              Bakterien hervorgerufen werden. Es gibt aber bestimmte
              muskuloskelettale Beschwerden, die bei einer Borreliose auftreten
              können. Dazu gehören kurzzeitige Gelenkschmerzen oder Arthritis in
              einem oder mehreren grösseren Gelenken, meist dem Kniegelenk. Wenn
              solche Merkmale fehlen, erhöht sich die Wahrscheinlichkeit für
              falsch positive Testergebnisse. Die Folge sind unnötige
              Behandlungen mit möglichen negativen Gesundheitsfolgen.
              Insbesondere diffuse Gelenk-­ oder Muskelschmerzen oder eine
              unklare Schmerzerkrankung (Fibromyalgie) deuten nicht auf eine
              Borreliose.
            </p>
            <p>
              <b>Fachgesellschaften:</b> Rheumatologie, Infektiologie
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 3,
    category: 'Diagnosen',
    title: 'Knieschmerzen',
    subtitle: 'Warten mit dem MRI',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-knieschmerzen.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Bei Schmerzen im vorderen Knie ohne
              Einschränkung der Beweglichkeit oder Gelenkerguss ist zuerst eine
              konservative Behandlung angezeigt. Ausnahme: Unfälle oder
              Verletzungen.
            </p>
            <p>
              <b>Nutzen:</b> Weniger falsche Befunde und dadurch unnötige
              Therapien durch eine vorschnelle Untersuchung im
              Magnetresonanztomografen (MRT oder MRI).
            </p>
            <p>
              <b>Hintergrund:</b> Eine MRI-Untersuchung ändert bei vorderen
              Knieschmerzen nichts daran, wie schnell oder gut sie heilen. Es
              existieren zwar nur wenige gut gemachte Studien. Doch diese zeigen
              bei Patientinnen und Patienten mit vorderen Knieschmerzen keine
              unterschiedlichen Verläufe von Schmerz und Beweglichkeit, ob nun
              eine MRI-Untersuchung durchgeführt wurde oder nicht. Wenn es sich
              nicht um einen Unfall handelt, reicht deshalb entweder einfach
              zuzuwarten oder konservativ mit Physiotherapie zu behandeln. Eine
              MRI-Untersuchung hat hingegen das Risiko von falsch positiven
              Befunden, die unnötige, riskante und kostspielige Eingriffe zur
              Folge haben können.
            </p>
            <p>
              <b>Fachgesellschaft:</b> Allgemeine Innere Medizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 4,
    category: 'Diagnosen',
    title: 'Schwindel',
    subtitle: 'Gezielte Befragung, keine Apparate',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-schwindel.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Bei akutem Schwindel sollte zuerst immer eine
              ärztliche Befragung und Untersuchung erfolgen, nicht direkt eine
              MRT-Messung.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Kosten, weniger unnötige Untersuchungen,
              weniger falsche Verdachtsbefunde.
            </p>
            <p>
              <b>Hintergrund:</b> Schwindel kann sehr viele verschiedene
              Ursachen haben, zum Beispiel Herz-Kreislauf-Erkrankungen, Probleme
              mit dem Gleichgewichtsorgan, Stoffwechselerkrankungen,
              Medikamenten-Nebenwirkungen, Augenerkrankungen oder auch
              Veränderungen im Nervensystem oder Gehirn. Patienten sollten
              deshalb zunächst gezielt befragt werden. Eine ärztliche
              Untersuchung der Augenbewegungen hilft ebenfalls bei der
              Ursachensuche. Zur Blickstabilisierung sind die Augenmuskeln im
              Gehirn mit dem Gleichgewichtsorgan (Innenohr) reflektorisch
              verbunden. Ein Test kann daher Hinweise liefern, ob der Schwindel
              auf Veränderungen im Gleichgewichtsorgan oder im Gehirn
              zurückzuführen ist. Eine Magnetresonanztomografie (MRT oder MRI)
              ist lediglich angezeigt, wenn eine Erkrankung im Gehirn wie ein
              Schlaganfall oder eine Hirnblutung vermutet wird.
            </p>
            <p>
              <b>Fachgesellschaft:</b> ORL, Hals- und Gesichtschirurgie
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 5,
    category: 'Diagnosen',
    title: 'Vitamin-D-Tests',
    subtitle: 'Ohne Risikofaktoren nutzlos',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-vitamin-d.svg')}
          className='cbImage therapieIcon'
          id='vitamin-d-tests'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Bei Personen, die keine Risikofaktoren für
              einen Mangel haben, muss Vitamin D nicht gemessen werden.
            </p>
            <p>
              <b>Nutzen:</b> Kosteneinsparungen bei gleicher
              Behandlungsqualität.
            </p>
            <p>
              <b>Hintergrund:</b> In der Schweiz wird mittlerweile jährlich bei
              jedem fünften Erwachsenen der Vitamin-D-Spiegel gemessen. Das ist
              eine Verdreifachung in sieben Jahren, ohne dass es dafür einen
              medizinischen Grund gäbe. Diese Messungen sind nur sehr selten
              sinnvoll, schreibt die SGAIM. Sie verursachen Kosten und haben
              meist keinen Einfluss auf das empfohlene Vorgehen beim Arzt. Das
              gilt sogar für Patientinnen und Patienten mit einem Risiko für
              einen Vitamin-D-Mangel. Sie können die preisgünstigen und
              risikoarmen Präparate auch ohne Test einnehmen. Die
              Einnahme-Empfehlung betrifft vor allem Osteoporose-Patienten,
              Schwangere und Neugeborene.
            </p>
            <p>
              <b>Fachgesellschaft:</b> Allgemeine Innere Medizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 6,
    category: 'Diagnosen',
    title: 'Rückenschmerzen',
    subtitle: 'Nicht gleich in die Röhre',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-rueckenschmerzen.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Bei Kreuzschmerzen ist es in der Regel besser,
              sechs Wochen zu warten, bevor eine bildgebende Diagnostik mittels
              CT oder MRI in Betracht gezogen wird.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Operationen, keine Komplikationsrisiken,
              keine Strahlenexposition, tiefere Kosten.
            </p>
            <p>
              <b>Hintergrund:</b> Die meisten Erwachsenen leiden im Laufe ihres
              Lebens an Rückenschmerzen. Meist sind sie unspezifisch, was
              bedeutet, dass sie sich keiner bestimmten Ursache zuordnen lassen.
              Oft stecken Muskelverspannungen dahinter. Die Schmerzen klingen
              dann oft innerhalb von wenigen Wochen ab. Eine Untersuchung mit
              bildgebenden Verfahren wie Computertomografie (CT) oder
              Magnetresonanztomografie (MRT oder MRI) ist in diesen Fällen
              während der ersten sechs Wochen kontraproduktiv. Sie bergen das
              Risiko von nachfolgenden Operationen, die weder Stärke noch Dauer
              der Schmerzen verringern. CT oder MRT sind allenfalls angezeigt,
              wenn der Arzt bei der Untersuchung auf Warnzeichen stösst,
              beispielsweise auf Gefühlsstörungen oder Lähmungserscheinungen in
              Beinen und Armen, oder auf Blasen- oder Darmprobleme.
            </p>
            <p>
              <b>Fachgesellschaft:</b> Allgemeine Innere Medizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 7,
    category: 'Medikamente',
    title: 'Cholesterinsenker',
    subtitle: 'Keine Neuverschreibung bei Senioren',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-cholesterinsenker.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Patientinnen und Patienten ohne
              Herz-Kreislauf-Erkrankung sollen ab 75 nicht neu
              cholesterinsenkende Statine einnehmen. Auch die Messung der
              Blutfette ist ab diesem Alter wenig hilfreich.
            </p>
            <p>
              <b>Nutzen:</b> Ohne Therapie keine Nebenwirkungen wie
              Muskelschmerzen, Magen-Darm-Beschwerden oder Kopfschmerzen,
              weniger unnötige Kosten.
            </p>
            <p>
              <b>Hintergrund:</b> In Studien haben Statine bei Betagten, die
              keine kardiovaskulären Vorerkrankungen haben, keinen oder
              höchstens einen geringen Nutzen. Es ist dabei unklar, ob die
              präventive Einnahme dieser Medikamente überhaupt
              Herz-Kreislauf-Ereignisse wie Herzinfarkte oder Schlaganfälle und
              Todesfälle verhindert. Gleichzeitig haben Statine einschneidende
              Nebenwirkungen wie Muskelschmerzen, Magen-Darm-Beschwerden,
              Kopfschmerzen, Juckreiz, erhöhte Leberwerte und Blutzuckerwerte,
              ein gesteigertes Diabetes-Risiko. Ohne Vorerkrankung ist es
              deshalb bei dieser Altersgruppe auch nicht sinnvoll, das
              Cholesterin im Blut zu bestimmen. Auch bei über 75-Jährigen mit
              Herz-Kreislauf-Krankheiten sollte der Entscheid für ein Statin
              erst nach ausführlicher Information und gemeinsam mit der
              Patientin oder dem Patienten gefällt werden.
            </p>
            <p>
              <b>Fachgesellschaft:</b> Allgemeine Innere Medizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 8,
    category: 'Medikamente',
    title: 'Eisentherapie',
    subtitle: 'Tabletten und Tropfen statt Infusionen, wenn überhaupt',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-eisentherapie.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Ohne ausgeprägten Eisenmangel, Blutarmut und
              Symptome braucht es keine Eisenpräparate. Infusionen sind nur in
              Ausnahmefällen sinnvoll.
            </p>
            <p>
              <b>Nutzen:</b> Keine zusätzlichen Kosten ohne Nutzen, keine
              unerwünschten Folgen.
            </p>
            <p>
              <b>Hintergrund:</b> Wenn die Eisenspeicher gut gefüllt sind
              (Ferritin-Wert über 15 μg/L) und weder Blutarmut noch Symptome
              vorliegen, bringen Eisenpräparate nichts. Selbst wenn Betroffene
              trotz guten Blut- und Eisen-Werten unter Müdigkeit oder
              Leistungsabfall leiden, ist der Nutzen einer solchen Behandlung
              fraglich. In gut gemachten Studien fühlen sich die meist
              weiblichen Patienten bestenfalls subjektiv leicht weniger müde,
              möglicherweise die Folge eines Placebo-Effekts. Falls aber
              aufgrund eines Mangels tatsächlich eine Eisensubstitution
              angezeigt ist, rät die SGAIM zuerst Eisenpräparate in Form von
              Tabletten oder Tropfen zu nehmen (Ausnahme: Aufnahmestörungen
              durch Magendarmerkrankung). Eiseninfusionen können in seltenen
              Fällen zu einem allergischen Schock führen oder einer Überladung
              der Eisenspeicher, die Organe wie Leber, Herz, Pankreas, Gehirn
              und Muskeln schädigen kann. Häufig sind unschöne Hautveränderungen
              an der Einstichstelle. Gegen unnötige Eiseninfusionen sprechen
              auch die höheren Behandlungskosten im Vergleich zu Präparaten.
            </p>
            <p>
              <b>Fachgesellschaft:</b> Allgemeine Innere Medizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 9,
    category: 'Medikamente',
    title: 'Opioide',
    subtitle: 'Bei Rückenschmerzen oder Migräne möglichst vermeiden',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-opioide.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Opiate gegen Schmerzen können starke
              Nebenwirkungen haben und bei Migräne die Beschwerden sogar
              verstärken.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Nebenwirkungen.
            </p>
            <p>
              <b>Hintergrund:</b> Die unerwünschten Wirkungen von Opiaten
              bereiten Ärztinnen und Ärzten schon länger Sorge. Neben Symptomen
              wie Verstopfung, Übelkeit, Müdigkeit und Schwindel fallen vor
              allem Abhängigkeit und Überdosierungen ins Gewicht. Bei Migräne
              helfen opioidhaltige Schmerzmittel zudem weniger gut als
              spezifische Migränemedikamente und können die Kopfschmerzen sogar
              verschlimmern. Sie sollten daher nur in Betracht gezogen werden,
              wenn andere Behandlungen keine Linderung bringen. Auch bei starken
              akuten Rückenschmerzen («Hexenschuss») gibt es keine Studien, die
              einen Nutzen durch opioidhaltige Schmerzmittel belegen. Bei
              Personen mit chronischen Rückenschmerzen konnte lediglich eine
              leichte Schmerzlinderung gezeigt werden. Diese Patienten sollten
              vorrangig nicht-medikamentös behandelt werden. Falls dies nicht
              hilft, sind gängige Schmerzmittel ohne Opioide angezeigt.
            </p>
            <p>
              <b>Fachgesellschaften:</b> Rheumatologie, Neurologie
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 10,
    category: 'Medikamente',
    title: 'Säureblocker',
    subtitle: 'Möglichst wenig und nur begrenzt',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-saeureblocker.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Magensäure-Blocker, auch
              Protonenpumpeninhibitoren (PPI) genannt, sollten in möglichst
              geringen Mengen und nur für begrenzte Zeit eingenommen werden.
            </p>
            <p>
              <b>Nutzen:</b> Weniger unnötige Kosten, weniger Nebenwirkungen.
            </p>
            <p>
              <b>Hintergrund:</b> Wenn zu viel Magensäure gebildet wird, führt
              dies manchmal zu Beschwerden. Die Verdauungsflüssigkeit kann auch
              in die Speiseröhre fliessen und dort die Schleimhaut schädigen.
              Die Folge sind Sodbrennen oder Schmerzen in der Magengegend bis
              hinauf zum Kehlkopf (Reflux-Erkrankung). Medikamente, die die
              Bildung von Magensäure verringern, lindern solche Beschwerden oft,
              sie haben aber auch Nebenwirkungen. Mit der Zeit kann
              beispielsweise die Knochenfestigkeit abnehmen und das
              Ansteckungsrisiko durch bestimmte Krankheitserreger steigen. Zudem
              gewöhnt sich der Magen an die Behandlung und produziert mehr
              Säure. Beim Absetzen des Medikaments entstehen dann manchmal
              stärkere Beschwerden als zuvor. Magensäure-Blocker oder ähnliche
              Medikamente sollten deshalb nicht in grossen Mengen und über
              längere Zeit eingenommen werden. Die Nebenwirkungen können dann
              den Nutzen der Behandlung übersteigen.
            </p>
            <p>
              <b>Fachgesellschaften:</b> Allgemeine Innere Medizin,
              Gastroenterologie
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 11,
    category: 'Medikamente',
    title: 'Antibiotika',
    subtitle: 'Kein Nutzen bei Erkältung',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-antibiotika.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Ärzte sollen unkomplizierte Infekte der oberen
              Luftwege nicht mit Antibiotika behandeln.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Antibiotikaresistenzen, weniger
              Nebenwirkungen, tiefere Kosten.
            </p>
            <p>
              <b>Hintergrund:</b> Schnupfen, Husten oder Halsschmerzen gehören
              zu den häufigsten Gründen, wieso der Hausarzt aufgesucht wird.
              Fast immer sind Viren die Schuldigen. Und gegen diese helfen
              Antibiotika nicht. Die Medikamente hindern ausschliesslich
              Bakterien am Wachsen, nicht jedoch Viren. Auch wenn die Symptome
              manchmal sehr unangenehm sind: Einfache Infekte der oberen
              Luftwege halten in der Regel höchstens ein bis zwei Wochen an und
              heilen von selbst ab. Antibiotika verkürzen diese Dauer nicht und
              bringen auch sonst keine Linderung. Dafür erhöhen sie das Risiko,
              dass antibiotikaresistente Bakterien entstehen. Bei diesen sind
              die Medikamente dann wirkungslos, wenn es beispielsweise bei einer
              bakteriellen Lungenentzündung wirklich ernst gilt.
            </p>
            <p>
              <b>Fachgesellschaften:</b> Allgemeine Innere Medizin,
              Infektiologie
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 12,
    category: 'Medikamente',
    title: 'Schlaf- und Beruhigungsmittel',
    subtitle: 'Möglichst keine Benzodiazepine',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-schlafmittel.svg')}
          className='cbImage therapieIcon'
          id='schlafmittel'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Bei älteren Erwachsenen, die unter
              Schlaflosigkeit, Unruhezuständen oder Verwirrtheit leiden, sollen
              Benzodiazepine oder ähnliche Arzneien nicht Mittel der ersten Wahl
              sein.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Stürze, Verkehrsunfälle, Hospitalisierungen
              und Todesfälle.
            </p>
            <p>
              <b>Hintergrund:</b> Benzodiazepine gehören zu den am häufigsten
              verschriebenen Psychopharmaka. Sie führen rasch zu Abhängigkeit
              und haben ein breites Spektrum an unerwünschten Wirkungen. Die
              Fachgesellschaften der Geriater und der Allgemeinmediziner raten,
              insbesondere bei älteren Erwachsenen nach Möglichkeit auf
              Benzodiazepine und auch auf andere Beruhigungs- oder Schlafmittel
              zu verzichten. «Grosse Studien zeigen immer wieder, dass sich das
              Risiko für Verkehrsunfälle, Stürze und Hüftfrakturen sowie
              Hospitalisierungen oder Tod bei älteren Menschen mehr als
              verdoppeln kann», schreiben sie. Ältere Patienten und das
              Gesundheitspersonal müssen den Nutzen und die potenziellen
              Gefahren der verschiedenen Behandlungsstrategien für
              Schlaflosigkeit, Unruhezustände oder Verwirrtheit kennen.
            </p>
            <p>
              <b>Fachgesellschaften:</b> Geriatrie, Allgemeine Innere Medizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 13,
    category: 'Früherkennung',
    title: 'Darmkrebs-Früherkennung',
    subtitle: 'Nur alle zehn Jahre',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-darmkrebs.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Nach einer unauffälligen Darmspiegelung sollte
              die nächste Untersuchung erst nach 10 Jahren erfolgen, bei
              unproblematischen Darmpolypen meist frühestens nach fünf Jahren.
              Im Alter sollte die Notwendigkeit der Untersuchung sorgfältig
              abgewogen werden.
            </p>
            <p>
              <b>Nutzen:</b> Weniger unnötige Untersuchungen, weniger
              Komplikationen, tiefere Kosten.
            </p>
            <p>
              <b>Hintergrund:</b> Eine Darmspiegelung ist neben regelmässigen
              Stuhluntersuchungen eine der beiden Möglichkeiten, Dickdarmkrebs
              frühzeitig zu erkennen. Sie wird ab dem 50. Lebensjahr regelmässig
              empfohlen. Weil dieser Krebs meist langsam entsteht, muss eine
              nächste Spiegelung erst nach zehn Jahren wiederholt werden, wenn
              keine Hinweise auf eine Krebserkrankung vorhanden sind.
              Vorwölbungen in der Darmschleimhaut, auch Darmpolypen genannt,
              entfernt der Arzt während der Spiegelung und lässt sie im Labor
              analysieren. Wenn nur ein oder zwei kleine Polypen vollständig
              entfernt wurden und kein Verdacht auf Krebs-Vorstufen besteht,
              braucht es erst nach fünf bis zehn Jahren eine erneute Spiegelung.
              Im hohen Lebensalter und bei schweren Vorerkrankungen sollten
              Ärzte die Untersuchung nur in gut begründeten Fällen vornehmen.
            </p>
            <p>
              <b>Fachgesellschaften:</b> Gastroenterologie, Chirurgie
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 14,
    category: 'Früherkennung',
    title: 'Gesundheitschecks',
    subtitle: 'Unnötige Therapien als Folge',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-gesundheitschecks.svg')}
          className='cbImage therapieIcon'
          id='check-ups'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Personen, die nicht unter Symptomen leiden,
              brauchen keine regelmässigen Check-ups. Ausnahme: Krebsscreening,
              Blutdruck- und Cholesterin-Messungen.
            </p>
            <p>
              <b>Nutzen:</b> Keine Fehlalarme, die zu Folgeuntersuchungen und
              -therapien mit möglichen Komplikationen führen, tiefere Kosten.
            </p>
            <p>
              <b>Hintergrund:</b> Personen ohne erkennbares Leiden profitieren
              nicht von wiederholten Gesundheitschecks. Es kommt weder zu
              weniger Herzinfarkten und Schlaganfällen, noch sinkt deswegen die
              Krebs- und die Gesamtsterblichkeit. Dem fehlenden Nutzen gegenüber
              stehen jedoch die negativen Folgen von Überdiagnostik. Falsch
              positive Resultate von Blutuntersuchungen, Elektrokardiogrammen
              sowie Messungen im Computer- oder Magnetresonanztomografen führen
              oft zu weiteren unnötigen Abklärungen. Sie generieren Kosten und
              können unnötige Behandlungen nach sich ziehen, die wiederum
              Komplikationsrisiken bergen. Von der Empfehlung ausgenommen sind
              Screening-Untersuchungen mit wissenschaftlich belegtem Nutzen,
              insbesondere einzelne Krebsvorsorgeuntersuchungen (vor allem
              Darmkrebs) sowie die Messung von Blutdruck und Cholesterinspiegel.
              Auch Lebensstilberatungen, etwa bei Rauchern oder bei Übergewicht,
              bringen etwas.
            </p>
            <p>
              <b>Fachgesellschaft:</b> Allgemeine Innere Medizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 15,
    category: 'Früherkennung',
    title: 'Prostatakrebs',
    subtitle: 'Zurückhaltung bei der Früherkennung',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-prostatakrebs.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Patienten ohne besondere Beschwerden oder
              Risikofaktoren sollen den Früherkennungstest von Prostatakrebs nur
              erhalten, wenn der Arzt eingehend über Risiken und Nutzen
              informiert hat.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Überbehandlung mit Inkontinenz und Impotenz
              als Folge.
            </p>
            <p>
              <b>Hintergrund:</b> Jeder vierte Mann in der Schweiz zwischen 50
              und 74 Jahren macht jährlich den Früherkennungstest. Dabei wird im
              Blut die Menge des prostataspezifischen Antigens (PSA) gemessen.
              Das gibt Hinweise auf einen möglichen Prostatakrebs. Allerdings
              ist die Aussagekraft umstritten. Grosse Studien zeigen einen
              fraglichen Nutzen bei erheblichen Risiken der Behandlung. Bei
              einer Operation oder Bestrahlung kommt es danach oft zu
              Inkontinenz und/oder Impotenz. «Die Patienten sollten das Risiko
              von Überdiagnostik und Überbehandlung verstehen, bevor sie sich
              einem Test unterziehen», schreibt die Schweizerische Gesellschaft
              für Allgemeine Innere Medizin (SGAIM). Die Aufklärung erfolgt
              dabei am besten in Form eines strukturierten Gesprächs, bei dem
              eine gemeinsame Entscheidung getroffen wird. Bei über 75-Jährigen
              soll der Screeningtest gar nicht angeboten werden. Grundsätzlich
              wächst Prostatakrebs oft nur sehr langsam und bleibt über Jahre
              beschwerdefrei. Aus diesem Grund kann es bei Patienten auch nach
              einer Diagnose sinnvoll sein, die Krebserkrankung zunächst zu
              beobachten und regelmässig zu kontrollieren.
            </p>
            <p>
              <b>Fachgesellschaften:</b> Allgemeine Innere Medizin,
              Radio-Onkologie
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 16,
    category: 'Im Spital/Heim',
    title: 'Blut- und Röntgenuntersuchungen',
    subtitle: 'Nicht ohne klare Fragestellung',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-roentgenuntersuchungen.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Im Spital sind umfangreiche Blut- oder
              Röntgenuntersuchungen in regelmässigen Abständen nur mit einer
              klaren Fragestellung sinnvoll.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Risiken, weniger nutzlose Abklärungen,
              tiefere Kosten.
            </p>
            <p>
              <b>Hintergrund:</b> Auch bei Blutanalysen, Röntgenbildern,
              Elektrokardiogrammen oder Blutgasanalysen gilt nicht: je mehr,
              desto besser. Solche Untersuchungen werden im Spital oft täglich
              oder in anderen regelmässigen Abständen verordnet. Doch ohne
              eindeutige Fragestellung sei dies nicht sinnvoll, sagen
              Fachgesellschaften. Solche Routineverordnungen würden im Vergleich
              zu gezielten Untersuchungen keinen zusätzlichen Nutzen bringen.
              Dafür haben sie manchmal Risiken und Nebenwirkungen. Oder sie
              können bei unklaren Befunden weitere aufwendige, oft nutzlose
              Abklärungen oder Eingriffe nach sich ziehen.
            </p>
            <p>
              <b>Fachgesellschaften:</b> Allgemeine Innere Medizin,
              Intensivmedizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 17,
    category: 'Im Spital/Heim',
    title: 'Bluttransfusion',
    subtitle: 'So wenig wie möglich',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-bluttransfusion.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Bei Transfusionen nur die minimal benötigte
              Menge von Blutkonserven verwenden.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Komplikationsrisiken, tiefere Kosten,
              geringerer Verbrauch von Spenderblut.
            </p>
            <p>
              <b>Hintergrund:</b> Bei stabilen Patienten im Spital empfehlen die
              Fachgesellschaften der Intensivmediziner und der
              Allgemeinmediziner, die kleinstmögliche Transfusionsmenge zu
              verwenden. Gerade genug, um Blutmangelsymptome zu lindern
              beziehungsweise einen sicheren Hämoglobinwert zu erreichen.
              Grössere Mengen der Blutkonserven (Erythrozyten-Konzentrat)
              bringen keine besseren Resultate, erzeugen jedoch höhere Kosten.
              Zudem besteht für die Patienten ein Risiko für Komplikationen, zum
              Beispiel eine Kreislaufüberlastung oder Lungenprobleme.
              Zurückhaltung bei den Transfusionen spart zudem gespendetes Blut.
            </p>
            <p>
              <b>Fachgesellschaften:</b> Allgemeine Innere Medizin,
              Intensivmedizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 18,
    category: 'Im Spital/Heim',
    title: 'Mobilisation',
    subtitle: 'Raus aus dem Krankenbett',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-mobilisation.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Ältere Menschen während des
              Krankenhausaufenthalts nicht zu lange im Bett liegen lassen.
            </p>
            <p>
              <b>Nutzen:</b> Schnellere Genesung, seltenere Stürze, weniger
              Rehabilitation, weniger Pflegeheimplatzierungen.
            </p>
            <p>
              <b>Hintergrund:</b> Über die Hälfte der älteren Menschen, die
              ursprünglich ohne Einschränkung gehen konnten, verlieren diese
              Fähigkeit während eines Spitalaufenthalts. Um dies zu verhindern,
              braucht es früh eine sogenannte Mobilisation. Das heisst, die
              Patienten sollen sich so bald wie möglich bewegen, auch wenn bei
              einer Erkrankung oder Operation der Heilungsprozess noch in vollem
              Gang ist. Das sei entscheidend für die Aufrechterhaltung der
              Funktionsfähigkeit älterer Menschen, schreibt die SGAIM. Die frühe
              Mobilisierung senkt die Dauer des Krankenhausaufenthalts und macht
              eine Rehabilitation oder eine Platzierung im Pflegeheim seltener
              notwendig. Schliesslich sinkt auch das Sturzrisiko und überhaupt
              die Sterblichkeit.
            </p>
            <p>
              <b>Fachgesellschaft:</b> Allgemeine Innere Medizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 19,
    category: 'Im Spital/Heim',
    title: 'Blasenkatheter',
    subtitle: 'Nicht aus Bequemlichkeit',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-blasenkatheter.svg')}
          className='cbImage therapieIcon'
          id='blasenkathetern'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Im Spital sollen Patienten keine dauerhaften
              Blasenkatheter erhalten, wenn dies nur dem Komfort dient.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Spitalinfektionen, tiefere Kosten.
            </p>
            <p>
              <b>Hintergrund:</b> In der Schweiz ziehen sich pro Jahr 70’000
              Patienten im Spital eine Infektion zu. Blasenkatheter sind dabei
              der häufigste Grund. Rund jede fünfte Spitalinfektion ist darauf
              zurückzuführen. Die SGAIM empfiehlt deshalb einen Verzicht auf
              Blasenkatheter bei Patienten mit Inkontinenz oder aus
              Bequemlichkeit ohne medizinischen Grund. Dadurch lässt sich nicht
              nur die Infektionsrate, sondern generell die Erkrankungs- und
              Sterbewahrscheinlichkeit senken. Auch die Behandlungskosten
              verringern sich. Die Schweizerische Gesellschaft für
              Intensivmedizin (SGI) fordert generell, auf invasive Instrumente
              wie Katheter, Sonden oder Drains zu verzichten, wenn kein Nutzen
              für den Patienten zu erwarten ist. Wenn der Einsatz jedoch aus
              medizinischen Gründen angezeigt ist, sollen die Ärzte die
              Notwendigkeit der Massnahme mit dem Ziel einer möglichst baldigen
              Entfernung immer wieder überprüfen.
            </p>
            <p>
              <b>Fachgesellschaften:</b> Allgemeine Innere Medizin,
              Infektiologie, Intensivmedizin
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 20,
    category: 'Im Spital/Heim',
    title: 'Aggressive Demenzpatienten',
    subtitle: 'Betreuung statt Psychopharmaka',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-demenzpatienten.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Keine Antipsychotika als erste Wahl bei
              Verhaltensauffälligkeiten oder psychischen Symptomen bei Demenz.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Stürze und Schlaganfälle, geringere
              Sterblichkeit, weniger Übersedierung.
            </p>
            <p>
              <b>Hintergrund:</b> Der Einsatz von antipsychotischen Medikamenten
              ist häufig. Gründe sind Aggressivität, Widerstand gegenüber dem
              Pflegepersonal oder andere schwierige Verhaltensweisen bei den
              Betroffenen. Die Medikamente haben nur eine begrenzte und
              unzuverlässige Wirksamkeit, sagt die Fachgesellschaft der
              Geriater. Dafür besteht das Risiko, dass die Patienten zu sehr
              gedämpft werden (Übersedierung) und sich der geistige Abbau
              beschleunigt. Es kommt öfter zu Stürzen, Schlaganfällen und einer
              erhöhten Sterblichkeit. «Die medikamentöse Behandlung von
              Demenzpatienten sollte sich auf Fälle beschränken, in denen
              nicht-medikamentöse Therapien keine Wirkung zeigen oder die
              Patienten eine unmittelbare Gefahr für sich selbst oder andere
              darstellen», heisst es in den Empfehlungen. Oft können Ursachen
              für eine Verhaltensänderung ermittelt und ohne Medikamente
              angegangen werden.
            </p>
            <p>
              <b>Fachgesellschaft:</b> Geriatrie
            </p>
          </div>
        </div>
      </>
    )
  },
  {
    nr: 21,
    category: 'Im Spital/Heim',
    title: 'Magensonde',
    subtitle: 'Normales Essen für Demente',
    graphic: (
      <>
        <Image
          file={require('../../images/icon-magensonde.svg')}
          className='cbImage therapieIcon'
        />
      </>
    ),
    text: (
      <>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              <b>Empfehlung:</b> Magensonden durch die Haut sind bei Patienten
              mit fortgeschrittener Demenz zu vermeiden.
            </p>
            <p>
              <b>Nutzen:</b> Weniger Unruhezustände, Beruhigungsmittel und
              Lungenentzündungen, geringere Sterblichkeit.
            </p>
            <p>
              <b>Hintergrund:</b> Patienten mit schwerer Demenz sollten, wenn
              immer möglich, von einer Pflegeperson bei der Nahrungseingabe
              vorsichtig unterstützt werden. Das braucht mehr Zeit und Personal
              als die Ernährung mittels einer sogenannten perkutanen Magensonde.
              Die Vorteile der normalen Nahrungszufuhr gegenüber der Magensonde
              sind laut der Schweizerischen Fachgesellschaft für Geriatrie
              (SFGG) erheblich: Das Sterblichkeitsrisiko sinkt, und es kommt
              seltener zu einer Lungenentzündung durch eingeatmeten Mageninhalt.
              Sondenernährung führt zudem öfter zu Unruhezuständen und macht
              häufiger den Einsatz von Fixierungen und medikamentöser
              Ruhigstellung nötig. Auch gibt es mehr sich verschlechternde
              Druckgeschwüre.
            </p>
            <p>
              <b>Fachgesellschaft:</b> Geriatrie
            </p>
          </div>
        </div>
      </>
    )
  }
]
